/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]     .k-i-checkmark.k-icon, [_nghost-%COMP%]     .k-i-checkmark.k-icon::before{display:none}[_nghost-%COMP%]     .k-upload .k-dropzone{background-color:#fff}[_nghost-%COMP%]     .k-upload .k-upload-files .k-file:last-child{border-width:0 1px 1px}"];
export { styles as styles };
